module.exports = __webpack_public_path__ + "img/icn_erases.54e78765.svg";